import { render, staticRenderFns } from "./AddLaundryType.vue?vue&type=template&id=6eabbc3b&"
import script from "./AddLaundryType.vue?vue&type=script&lang=js&"
export * from "./AddLaundryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports